/*
  GST price view, currently used on the PDP only (sections/main-product-v2.liquid).

  - Default view is always inc GST: that is what the server renders and what Google checks.
  - A visitor's choice is kept in localStorage and applied to every [data-gst-price] element,
    including cards that arrive later (filtering, pagination, recommendations).
  - Every [data-gst-toggle] on the page stays in sync.
  - Other scripts (the PDP variant picker) read WhiskGst.mode and listen for 'whisk:gst-view'.

  Toggle markup is snippets/whisk-gst-toggle.liquid. Any element marked [data-gst-price]
  with data-ex / data-inc cents (and optional [data-gst-label]) follows the view too.
*/
(function () {
  if (window.WhiskGst) return;

  var KEY = 'whisk_gst_view';
  var mode = 'inc';
  try { if (localStorage.getItem(KEY) === 'ex') mode = 'ex'; } catch (e) {}

  function fmt(cents, noZeros) {
    var s = '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return noZeros ? s.replace(/\.00$/, '') : s;
  }

  function apply(root) {
    root = root || document;
    var ex = mode === 'ex';
    root.querySelectorAll('[data-gst-price]').forEach(function (el) {
      var cents = parseInt(ex ? el.dataset.ex : el.dataset.inc, 10);
      if (!isNaN(cents)) el.textContent = fmt(cents, el.hasAttribute('data-no-zeros'));
    });
    root.querySelectorAll('[data-gst-label]').forEach(function (el) {
      el.textContent = ex ? 'ex. GST' : 'inc. GST';
    });
    document.querySelectorAll('[data-gst-toggle] [data-gst-mode]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.gstMode === mode ? 'true' : 'false');
    });
    document.documentElement.setAttribute('data-gst-view', mode);
  }

  function set(next) {
    if (next !== 'inc' && next !== 'ex') return;
    if (next === mode) return;
    mode = next;
    try { localStorage.setItem(KEY, mode); } catch (e) {}
    if (window.clarity) window.clarity('event', mode === 'ex' ? 'gst_view_ex' : 'gst_view_inc');
    apply();
    document.dispatchEvent(new CustomEvent('whisk:gst-view', { detail: { mode: mode } }));
  }

  window.WhiskGst = {
    get mode() { return mode; },
    set: set,
    apply: apply,
    withGst: function (cents, taxable) { return taxable ? Math.round(cents * 1.1) : cents; },
    format: fmt
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-gst-toggle] [data-gst-mode]');
    if (btn) set(btn.dataset.gstMode);
  });

  function start() {
    apply();
    // Re-apply to cards injected after load. Only needed when the visitor is on ex GST,
    // since freshly rendered markup is already inc GST.
    if ('MutationObserver' in window) {
      new MutationObserver(function (records) {
        if (mode !== 'ex') return;
        for (var i = 0; i < records.length; i++) {
          var nodes = records[i].addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            var n = nodes[j];
            if (n.nodeType === 1 && (n.matches('[data-gst-price],[data-gst-label],[data-gst-toggle]') || n.querySelector('[data-gst-price],[data-gst-label],[data-gst-toggle]'))) {
              apply();
              return;
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
